import * as types from './constants';

// Update Lookbook
export const updateLookbookRequest = data => (
  { type: types.UPDATE_LOOKBOOK_REQUEST, payload: data }
);

export const updateLookbookDone = data => (
  { type: types.UPDATE_LOOKBOOK_DONE, payload: data }
);

export const updateLookbookFailed = errors => (
  { type: types.UPDATE_LOOKBOOK_FAILED, payload: errors }
);

export const updateLookbookClearErrors = prop => (
  { type: types.UPDATE_LOOKBOOK_CLEAR_ERRORS, payload: prop }
);

export const updateLookbookReset = () => (
  { type: types.UPDATE_LOOKBOOK_RESET }
);